import React, { useState, useEffect, useCallback } from 'react'

import isDark from 'utils/isDark'

import { ContainerImg } from './styles'

const IcShoppingBasket = ({ fill = '#161616' }) => (
  <svg
    data-testid="fallback-icon"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height="45"
    width="45"
  >
    <path
      fill={fill}
      fillRule="evenodd"
      d="M7.624 5.176A3 3 0 0 1 10.509 3h2.982a3 3 0 0 1 2.885 2.176L17.754 10h2.224a.98.98 0 0 1 .042 0H21a1 1 0 1 1 0 2h-.198l-1.478 6.65A3 3 0 0 1 16.396 21H7.604a3 3 0 0 1-2.928-2.35L3.198 12H3a1 1 0 1 1 0-2H6.246l1.378-4.824ZM5.247 12l1.381 6.217a1 1 0 0 0 .976.783h8.792a1 1 0 0 0 .976-.783L18.753 12H5.247Zm9.206-6.275L15.674 10H8.326l1.221-4.275A1 1 0 0 1 10.51 5h2.982a1 1 0 0 1 .962.725Z"
      clipRule="evenodd"
    />
  </svg>
)

interface ImageWithFallbackProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string | undefined
  alt: string
}

const ImageWithFallback: React.FC<ImageWithFallbackProps> = ({ src, alt, ...props }) => {
  const [imgSrc, setImgSrc] = useState<string | undefined>(src)
  const [useFallback, setUseFallback] = useState(false)
  const [isDarkMode, setIsDarkMode] = useState(false)

  useEffect(() => {
    setImgSrc(src)
    setUseFallback(false)
  }, [src])

  useEffect(() => {
    isDark().then((darkMode) => setIsDarkMode(darkMode))
  }, [])

  const handleError = useCallback(() => {
    if (!useFallback) {
      setUseFallback(true)
    }
  }, [useFallback])

  if (useFallback) {
    return (
      <ContainerImg>
        <IcShoppingBasket fill={isDarkMode ? 'white' : '#161616'} />
      </ContainerImg>
    )
  }

  return <img {...props} src={imgSrc} onError={handleError} alt={alt} />
}

export default ImageWithFallback
